/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SubnetConfig } from '../models/SubnetConfig';
import { VNetConfig } from '../models/VNetConfig';

/**
* Network interface configuration for Azure VM restore. Use mode=existing to attach an existing NIC, or mode=create to create a new NIC. 
*/
export class NetworkInterfaceConfig {
  /**
  * Whether to use an existing NIC or create a new one
  */
  'mode': NetworkInterfaceConfigModeEnum;
  /**
  * Full Azure resource ID of the existing NIC. Required when mode=existing. Format: /subscriptions/{sub}/resourceGroups/{rg}/providers/Microsoft.Network/networkInterfaces/{name} 
  */
  'nicId'?: string;
  /**
  * Name for the new NIC. Only used when mode=create. Defaults to <vmName>-nic if not specified. 
  */
  'nicName'?: string;
  'vnet'?: VNetConfig;
  'subnet'?: SubnetConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "mode",
      "baseName": "mode",
      "type": "NetworkInterfaceConfigModeEnum",
      "format": ""
    },
    {
      "name": "nicId",
      "baseName": "nicId",
      "type": "string",
      "format": ""
    },
    {
      "name": "nicName",
      "baseName": "nicName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vnet",
      "baseName": "vnet",
      "type": "VNetConfig",
      "format": ""
    },
    {
      "name": "subnet",
      "baseName": "subnet",
      "type": "SubnetConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NetworkInterfaceConfig.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum NetworkInterfaceConfigModeEnum {
  Existing = 'existing',
  Create = 'create'
}

